import { Component, OnInit, NgZone } from '@angular/core';
import { Advisor } from '../models/advisor';
import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { PagerService } from '../services/pager.service';
import { LoadingService } from '../shared/loading/loading.service';
import { Router } from "@angular/router"

@Component({
  selector: 'app-advisors',
  templateUrl: './advisors.component.html',
  styleUrls: ['./advisors.component.css']
})
export class AdvisorsComponent implements OnInit {
  public advisors: any[] = [];
  public error: string;

  public screenWidth: number = window.innerWidth;

  private allItems: any[];
  private filteredAdvisors: any;
  pager: any = {};
  pagedItems: any[];

  constructor(private globalService:GlobalService, private modalService: ModalService, private pagerService: PagerService, private ngZone: NgZone, private loadingService: LoadingService, private router: Router) {
    this.globalService.featHomeOffice = JSON.parse(localStorage.getItem('featHomeOffice'));
    
    this.getAdvisors();

    // window.onresize = () => { // Detect screen size and resizing
    //   ngZone.run(() => {
    //     this.screenWidth = window.innerWidth;
    //   })
    // }
  }

  getAdvisors() {
    this.loadingService.isLoading(true);

    this.globalService.getAdvisorsData(1)
      .subscribe(
        advisors => {
          this.allItems = advisors;

          // this.allItems = this.allItems.reduce((arr, item) => {
          //   if (!!item.FirstName && item.FirstName != 'undefined')
          //     arr.push(item);
          //   return arr;
          // }, []);

          this.allItems = advisors.map((item) => {
            item.c.OrganizationName = item.o.Name;
            return item.c;
          });

          this.filteredAdvisors = this.allItems.sort(function (a, b) {
            return parseInt(b.ID) - parseInt(a.ID);
          });

          this.filteredAdvisors.map((advisor) => {
           if (advisor.Phone.indexOf("-") == -1 && advisor.Phone.indexOf("(") == -1 && advisor.Phone.indexOf(")") == -1)
             advisor.Phone = this.onPhoneInputChange(advisor.Phone);
          });

          this.setPage(1);
          this.loadingService.isLoading(false);
        },
        error => {
          this.error = <any>error
          this.loadingService.isLoading(false);
        });
  }

  onPhoneInputChange(event) {
    let newVal = event.replace(/\D/g, '');
    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length <= 3) {
      newVal = newVal.replace(/^(\d{0,3})/, '($1)');
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
    } else if (newVal.length <= 10) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    } else {
      newVal = newVal.substring(0, 10);
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    }
    //this.ngControl.valueAccessor.writeValue(newVal);
    return newVal;
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.filteredAdvisors.length, page);

    // get current page of items
    this.pagedItems = this.filteredAdvisors.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    // unsubscribe to ensure no memory leaks
    // this.subscription.unsubscribe();
  }

  handleCreateAdvisorModal() {
    //this.modalService.add('create-advisor', { ID: 0 });
    this.router.navigate(['/advisors/create'], { state: { ID: 0 } });
  }

  handleEditAdvisorModal(e, advisor) {
    //this.modalService.add('edit-advisor', { ID: advisor.ID });
    this.router.navigate(['/advisors/edit'], { state: { ID: advisor.ID } });
  }

  handleCreateClientModal(e, advisor) {
    localStorage.setItem('advisor', JSON.stringify(advisor));
    localStorage.setItem('isCreateClient', "True");
    this.router.navigate(['/clients/create']);
  }

  assignCopy(){
    this.filteredAdvisors = Object.assign([], this.allItems);
  }

  createNewAdvisor(){
    this.router.navigate(['/advisors/create'], { state: { ID: 0 } });
  }

  filterItem(value) {
    this.filteredAdvisors = Object.assign([], this.allItems).filter(
      advisor => {
        return (advisor.FirstName + " " + advisor.LastName).toLowerCase().includes(value.toLowerCase()) || (advisor.OrganizationName).toLowerCase().includes(value.toLowerCase()) || (advisor.Phone).toLowerCase().includes(value.toLowerCase()) || (advisor.Email).toLowerCase().includes(value.toLowerCase())
      }
    );

    if (!this.filteredAdvisors.length) {
      this.pagedItems = [];
    } else {
      this.setPage(1);
    }
  }

}
